<template>
    <div id="home" style="
        min-width: 1566px;
        min-height: 768px;">
        <div class="scroll">
            操作说明：<br />
            1、账号为身份证号（如有X,须大写）。<br />
            2、有药师网账号、且没有重设过密码的，初始密码为“px身份证后六位%”（如：px123456%）；如果忘记密码请重置密码，密码必须包含<span class="red">“字母、数字、特殊符号”</span>。为保障个人信息安全，请定期更换密码。<br />
            3、如果提示验证码错误，请更换360、火狐或谷歌浏览器后，多次点击刷新出现极易辨认的验证码后再输入。<br />
            4、如果没有注册或此前没有药师网账号，请点击注册账户。游客访问无法报名学习。<br />
            5、手机浏览器访问网站进行学习无法累计观看时长，请通过电脑端访问网站或手机端微信关注“省药品信息宣传和发展服务中心”公众号，登录学习平台报名学习。<br />
            6、基本流程为：<span class="red">登录—报名—缴费—学习—填写调查问卷</span>，详情参见平台首页<a class="line" href="https://mpsc.zjfda-tc.org.cn/#/tzdetail/9" target="_blank">《继续教育流程说明》</a>。
        </div>
        <div class="login_login">
            <div class="flexHeadTitle">
              <img class="login_logo" src="../../../assets/img/login/loginlogo.png" alt="" />
              <div class="login_logo_title">
                  <div class="logo_1">浙江省药品信息宣传和发展服务中心</div>
                  <div class="logo_2">继续教育学习平台</div>
              </div>
            </div>
           
            <div class="zcxingshi">
                <span @click="clgenren()" id="ge" :style="{ color: num == 0 ? '#3562e8' : '#333' }">个人用户登录</span>
                <!-- <div :class="{ gun: flag }"></div> -->
                <span @click="cl1qiye()" :style="{ color: num == 1 ? '#3562e8' : '#333' }" style="margin-left: 47px">企业用户登录</span>
            </div>
            <div class="demo-input-size">
                <div class="tips2" v-show="num==0">联系电话：0571-88903230、88903229、88903228</div>
                <div class="tips2" v-show="num==0">电子邮箱：zjfzfwzx@163.com</div>
                <div class="tips" v-show="num==1">企业用户请用账号密码登录</div>
                <el-input v-if="num==0"  placeholder="请输入18位身份证号码" v-model="userName" @mouseenter.native="mo=true" @mouseleave.native="mo=false" @keyup.enter.native="logins">
                  <img slot="prefix" class="userNamePrefix" src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1681367211596.png">
                </el-input>
                <el-input v-if="num==1"  placeholder="企业用户使用登录账号登录" v-model="userName" @mouseenter.native="mo=true" @mouseleave.native="mo=false" @keyup.enter.native="logins">
                      <img slot="prefix" class="userNamePrefix" src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1681367211596.png">
                </el-input>
                <el-input  placeholder="账户密码" type="password" v-model="passWord" @keyup.enter.native="logins" show-password>
                      <img slot="prefix" class="passWordPrefix" src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1681367207124.png">
                </el-input>
                <el-input  placeholder="请输入验证码，不区分大小写" maxlength="8" style="margin-bottom: 0;" v-model="codeValue" @keyup.enter.native="logins">
                      <img slot="prefix" class="verCodePrefix" src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1681367185745.png">
                      <img slot="suffix" @click="changeUrl" :src="imgUrl" class="imgUrl" />
                </el-input>

                <div>
                    <div class="flexs">
                        
                        <span class="wpa" @click="password()">重置密码</span>
                    </div>
                </div>
            </div>
            <el-button class="login" @click="logins">登录</el-button>
            <div class="fuza">
                <span @click="cl()">游客访问</span>
                <span  @click="clri()">注册账户</span>
            </div>

            <div class="fenge">
                <span class="line_line3"></span>
                <span class="text_line3">第三方登录</span>
                <span class="line_line3"></span>
            </div>
            <div class="weixinlogin" @click="wlogin()">
                <img class="weixintu" src="../../../assets/img/login/weixin.png" alt="" />
                <span>微信登录</span>
                <Modal v-model="modal1" id="box_weixin" title="扫码登录" width="35">
                    <div class="modal" v-if="modal">
                        <div class="pubilcView">
                            <img src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1626684645629.jpg" class="pubilcImg" />
                        </div>
                        <div id="login_container"></div>
                        <div class="red">*首次使用扫码登录的用户，请扫描左侧二维码关注“省药品信息宣传和发展服务中心”微信公众号，点击“继续教育”进入继续教育H5端登录后，再扫描右侧二维码进行登陆</div>
                    </div>
                    <div v-if="!modal" @click="modal = true" class="maskLayer">二维码失效点击刷新</div>
                </Modal>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        login,
        getVerify,
        vxLogin
    } from "network/home";
    import {
        ItemImgList
    } from "common/minix";
    import {
        getNews,
    } from "../../../network/LPersonal";
    import Cookies from "js-cookie";
    import md5 from "js-md5";
    import './wxLogin'
    export default {
        name: "Login",

        components: {},

        mixins: [ItemImgList],

        data() {
            return {
                mo: false,
                showis: false,
                modal: false,
                userName: null,
                passWord: null,
                code: null,
                banners: [],
                recommends: [],
                url: null,
                userInfo: {},
                info: "",
                imgUrl: null,
                codeValue: null,
                uuid: null,
                value: 0,
                size: 150,
                type: "",
                modal1: false,
                cur: 0,
                num: 0
            };
        },
        activated() {
            this.userName = null
            this.passWord = null
            this.codeValue = null
            this.getCoed();
            this.$store.commit("setTabBarShow", false);

        },
        //组件创建前调用的生命周期
        beforeCreate() {
            // //vue引入外部js文件
            const q = document.createElement("script");
            q.type = "text/javascript";
            q.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
            document.head.appendChild(q);
        },
        deactivated() {
            this.$store.commit("setTabBarShow", true);
        },

        async created() {
            this.username = "";
            this.passWord = "";
            (this.codeValue = ""), this.getCoed();
            if (this.$route.query.code) {
                this.code = this.$route.query.code
            }
            console.error("测试测试", this.test2());
        },
        watch: {
            $route() {
                this.code = this.$route.query.code
            },
            code() {
                if (window.location.href.indexOf("code")) this.vxLogin()
            },
            modal() {
                let time = null
                if (this.modal) {
                    this.wlogin()
                    this.$Notice.warning({
                        title: '提示',
                        desc: '需关注公众号并登录后才可使用扫码登录功能'
                    })
                    time = setTimeout(() => {
                        this.modal = false
                    }, 60000);
                } else {
                    clearTimeout(time)
                    time = null
                }
            }
        },
        methods: {
            cl1qiye() {
                this.num = 1
            },
            clgenren() {
                this.num = 0
            },
            async test() {
                let aa = await new Promise((resolve, reject) => {
                    setTimeout(() => resolve("done!"), 1000)
                });
                return await aa;
            },
            async test2() {
                await this.test();
            },
            vxLogin() {
                vxLogin(window.location.href.split("code=")[1].split("&")[0]).then(r => {
                    if (r.data.code == 200) {
                        this.Set("userId", r.data.data.user.id);
                        this.Set("token", r.data.data.user.userToken);
                        this.Set("type", r.data.data.user.type);
                        this.Set("mobile", r.data.data.user.mobile);
                        this.Set("username", r.data.data.user.idCard);
                        if (r.data.data.user.isAuth == 1) {
                            window.location.href = '/#/index'
                            // this.$router.push("/index"); 
                        } else {
                            window.location.href = '/#/Authentication'
                            // this.$router.push("/Authentication")
                        }
                        this.modal1 = false
                    } else {
                        this.modal = false
                        this.$Message.error("登录失败,请刷新重试")
                    }
                })
            },
            password() {
                this.$router.push("/wangjimima");
            },
            clri() {
                this.$router.push("/register");
            },
            wlogin() {
                this.modal = true;
                this.$nextTick(res => {
                    this.modal1 = true;
                    //全局环境变量修改
                    const obj = new WxLogin({
                        id: "login_container", // 需要显示的容器id
                        appid: "wx0ca26d24543064fd", // 公众号appid wx*******
                        scope: "snsapi_login", // 网页默认即可
                        redirect_uri: encodeURIComponent("http://mpsc.zjfda-tc.org.cn/#/login"), // 授权成功后回调的
                        state: Math.ceil(Math.random() * 1000), // 可设置为简单的随机数加session用来校验
                        style: "white", // 提供"black"、"white"可选。二维码的样式
                        href: "", // 外部css文件url，需要https
                    });
                })
            },
            cl() {
                this.$router.push("/index");
            },

            getCoed() {
                getVerify().then((res) => {
                    console.log(res);
                    this.imgUrl = "data:image/jpeg;base64," + res.data.image;
                    this.uuid = res.data.uuid;
                    this.$forceUpdate();
                });
            },

            changeUrl() {
                this.getCoed();
                this.$forceUpdate();
            },

            Set(name = "default", value = "", cookieSetting = {}) {
                let currentCookieSetting = {
                    expires: 1,
                };
                Object.assign(currentCookieSetting, cookieSetting);
                Cookies.set(`admin-${name}`, value, currentCookieSetting);
            },
            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            logins() {
                if (
                    this.userName === null ||
                    this.userName === undefined ||
                    this.userName === ""
                ) {
                    this.$Message.error("请输入账号");
                    return;
                }
                if (
                    this.passWord === null ||
                    this.passWord === undefined ||
                    this.passWord === ""
                ) {
                    this.$Message.error("请输入密码");
                    return;
                }
                let code = this.codeValue;
                console.log(this.userName, this.passWord, code, this.uuid);
                login({
                    username:this.sm4Encrypt(this.userName),
                    password: md5(this.passWord),
                    verificationCode: code,
                    uuid: this.uuid,
                }).then((res) => {
                    console.log(res, "-----------");
                    if (res.data.code === 200) {

                        this.Set("userId", res.data.data.id);
                        this.Set("token", res.data.data.userToken);
                        this.Set("type", res.data.data.type);
                        this.Set("mobile", res.data.data.mobile);
                        this.Set("password", this.passWord);
                        this.Set("username", this.userName);

                        if (res.data.msg == '请修改密码') {
                            this.$router.push("/changePassword");
                            this.$message.error(res.data.msg);
                        } else {
                            if (res.data.data.isAuth == 1) {
                                this.$router.push("/index");
                            } else {
                                this.$router.push("/Authentication")
                            }
                        }
                    } else {
                        this.$message.error(res.data.msg);
                        this.getCoed();
                    }
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    #home {
        background-image: url("../../../assets/img/login/loginHome.png");
        background-size: 100% 922px;
        background-repeat: no-repeat;
        width: 100%;
        height: 922px;
        background-size: 100% 100%;
        position: relative;
        padding-top: 43px;
        display: flex;
        justify-content: space-between;
        .scroll {
            width: 706px;
            height: 498px;
            border-radius: 8px;
            color: #000;
            font-size: 16px;
            font-family: Microsoft YaHei;
            overflow: hidden;
            overflow-y: auto;
            line-height: 36px;
            -ms-overflow-style: none;
            margin: 85px 0 0 10vw;
            /* IE 10+ */
        }

        .scroll::-webkit-scrollbar {
            display: none;
        }
    }


    .maskLayer {
        width: 490px;
        height: 453px;
        background-color: rgb(87, 87, 87, 0.5);
        color: #fff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .login_login {
        width: 650px;
        height: 838px;
        background-color: #fff;
        text-align: left;
        box-shadow: 0px 0px 10px 0px rgba(0, 108, 255, 0.1);
        border-radius: 26px;
        padding: 33px 96px;
        margin-right: 15px;
        // position: relative;
    }

    .login_logo_title {
      margin-left: 15px;
    }

    .logo_1 {
        height: 33px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
    }

    .logo_2 {
        height: 32px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        text-align: left;
    }

    .demo-input-size {
        width: 500px;
        margin-top: 25px;
        position: relative;
    }

    .wpa {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2C7EFC;
      margin-right: 35px;
    }

    .fuza {
        height: 30px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #273149;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding: 0 35px;
    }

    .line_line3 {
        display: inline-block;
        width: 160px;
        border-top: 1px solid #cccccc;
        vertical-align: 5px;
        background: #1e41a6;
        opacity: 0.8;
    }

    .text_line3 {
        margin-right: 25px;
        margin-left: 25px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7f7f7f;
    }

    .fenge {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .weixinlogin {
        height: 80px;
        margin-top: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 14px;
        font-family: Microsoft YaHei;
        color: #7F7F7F;
    }

    .wz {
        display: inline-block;
        width: 60px;
        height: 18px;
        margin-left: 217px;
        margin-top: 10px;
    }

    .weixintu {
        width: 47px;
        height: 47px;
        margin-bottom: 14px;
    }

    #box_weixin {
        display: flex;
        justify-content: center;

    }

    #login_container {
        display: flex;
        justify-content: center;
    }

    .zcxingshi {
        font-size: 18px;
        font-weight: bold;
        font-family: Microsoft YaHei;
        color: #000000;
        position: relative;
        margin-top: 36px;
    }

    .kuang {
        width: 200px;
        height: 80px;
        border: 1px red solid;
        position: absolute;
        top: 0;
        right: -180px;
        font-size: 18px;
    }

    .tips {
        height: 30px;
        line-height: 30px;
        color: red;
        font-size: 14px;
    }

    .tips2 {
        color: black;
        font-size: 14px;
        margin-bottom: 15px;
    }

    .flexs {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 15px;
        margin-bottom: 27px;
        padding-right: 35px;
    }

    .modal {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }

    .pubilcImg {
        width: 282px;
        height: 282px;
        margin-top: -24px;
        border: 1px solid #E2E2E2;
    }

    .pubilcView {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 282px;
        height: 400px;
    }

    .h1 {
        font-size: 24px;
    }

    .red {
        color: red !important;
    }
    .flexHeadTitle {
      display: flex;
      justify-content: center;
    }
    /deep/ .el-input__inner {
      height: 60px;
      line-height: 60px;
      border: 1px solid #999;
      border-radius: 8px;
      font-size: 16px;
      padding-left: 77px;
      padding-right: 125px;
      width: 469px;
    }
    /deep/ .el-input {
      margin-bottom: 30px;

    }

    .userNamePrefix {
      width: 26PX;
      height: 26px;
    }
    .passWordPrefix {
      width: 22px;
      height: 29px;
    }
    .verCodePrefix {
      width: 22px;
      height: 26px;
    }

    /deep/ .el-input__prefix{
      height: 100%;
      width: 77px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .3s;
    }

    /deep/ .el-input__suffix{
      right: 50px;
    }
    .login {
      width: 469px;
      height: 61px;
      background: #3562E8;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .imgUrl {
      width: 124px;
      height: 40px; 
      margin-top: 10px;  
      margin-left: 10px; 
      display: inline-block;
    }
    
    .login_logo {
      width: 65px; 
      height: 64px;
    }

    .line {
        text-decoration: underline;
    }
</style>
